import { Descriptions, Divider, Drawer } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cashConverter } from "../../../utils";

function FloodControlView({ onClose, open, prodd }) {
  const navigate = useNavigate();

  const items1 = [
    {
      key: "1",
      label: "Project Name",
      children: prodd?.floodName ?? "N/A",
    },
    
    {
      key: "2",
      label: "Dyke Type",
      children: prodd?.dtType ?? "N/A",
    }, 
    {
      key: "5",
      label: "Acreage Farmed",
      children: prodd?.floodAcreageFarmed ?? "N/A",
    },
    {
      key: "6",
      label: "Start Date",
      children: (
        <div>
          {prodd?.floodStartDate
            ? moment(prodd?.floodStartDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "7",
      label: "End Date",
      children: (
        <div>
          {prodd?.floodEndDate
            ? moment(prodd?.floodEndDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "8",
      label: "Budget/Cost",
      children: prodd?.floodCost ?? "N/A",
    },
   
    {
      key: "9",
      label: "Remarks",
      children: prodd?.floodRemarks ?? "N/A",
    },
    {
      key: "10",
      label: "Scope",
      children: prodd?.floodScope ?? "N/A",
    },
    {
      key: "13",
      label: "Height",
      children: prodd?.floodDykeHeight ?? "N/A",
    }, 
    {
      key: "15",
      label: "Category",
      children: prodd?.flCategory ?? "N/A",
    },
    
    
  ];
  const items2 = [
    {
      key: "5",
      label: "County",
      children: prodd?.countyCode ?? "N/A",
    },
    {
      key: "1",
      label: "SubCounty",
      children: prodd?.subCountyCode ?? "N/A",
    },
    {
      key: "2",
      label: "Location",
      children: prodd?.locLocation ?? "N/A",
    },
    {
      key: "3",
      label: "SubLocation",
      children: prodd?.slocLocation ?? "N/A",
    },
    {
      key: "45",
      label: "Constituency",
      children: prodd?.constName ?? "N/A",
    },
    {
      key: "4",
      label: "Ward",
      children: prodd?.wdWard ?? "N/A",
    }, 
    {
      key: "2",
      label: "Cost",
      children: <div>{cashConverter(prodd?.floodCost)}</div>,
    },
    
    {
      key: "8",
      label: "Funding Source",
      children: prodd?.floodSourceFunds ?? "N/A",
    }, 
    {
      key: "11",
      label: "Estimated Beneficiaries",
      children: prodd?.floodEstBeneficiaries ?? "N/A",
    },
    {
      key: "12",
      label: "Pathways",
      children: prodd?.floodPathways ?? "N/A",
    },
    {
      key: "12",
      label: "Implementing Agency",
      children: prodd?.floodAgency ?? "N/A",
    },
    {
      key: "13",
      label: "Managing Entity",
      children: prodd?.floodManagingAgency ?? "N/A",
    },
   
    
  ];
 
  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">Flood Control Infomation</div>
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title=""
          column={1}
          colon={false}
          items={items1}
          layout="vertical"
        />
        <Descriptions
          title=""
          column={1}
          colon={false}
          items={items2}
          layout="vertical"
        />
        
      </div>
    </Drawer>
  );
}

export default FloodControlView;
